import { collectAttribution } from "./attribution.js";

/**
 * Collects page and browser context for each event.
 * Safe to call in SSR / non-browser environments — all access is guarded.
 * Designed to be called on every event (context may change on SPA navigation).
 */
export function collectPageContext(): Record<string, unknown> {
  const ctx: Record<string, unknown> = {};

  if (typeof window === "undefined") {
    return ctx;
  }

  // Page URL info
  if (typeof document !== "undefined") {
    const loc = document.location;
    ctx.url = loc.href;
    ctx.path = loc.pathname;
    ctx.search = loc.search;
    ctx.referrer = document.referrer;
    ctx.title = document.title;
  }

  // Navigator info
  if (typeof navigator !== "undefined") {
    ctx.locale = navigator.language;
    ctx.user_agent = navigator.userAgent;
  }

  // Timezone (can throw in some environments)
  try {
    ctx.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    // timezone remains unset
  }

  // Screen dimensions
  if (typeof screen !== "undefined") {
    ctx.screen = {
      width: screen.width,
      height: screen.height,
      density: window.devicePixelRatio,
    };
  }

  // Viewport dimensions
  ctx.viewport = {
    width: window.innerWidth,
    height: window.innerHeight,
  };

  // Attribution (UTM params, click IDs)
  const attribution = collectAttribution();
  if (Object.keys(attribution).length > 0) {
    ctx.attribution = attribution;
  }

  return ctx;
}
